var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13439_38358)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 0.855957H0V29.856H29V0.855957ZM11.5509 18.4453C12.3822 19.1013 13.4242 19.4605 14.4997 19.4619C15.5752 19.4604 16.6171 19.1012 17.4485 18.4453C18.2797 17.7892 18.8493 16.8767 19.0602 15.8629H22.9994V20.537C22.9994 21.2418 22.7081 21.9179 22.1896 22.4162C21.6712 22.9148 20.9679 23.1947 20.2347 23.1947H8.76473C8.03155 23.1947 7.32822 22.9147 6.80982 22.4162C6.29123 21.9179 6 21.2419 6 20.537V15.8629H9.93922C10.1501 16.8768 10.7196 17.7893 11.5509 18.4453ZM20.235 6.85596H8.76512C8.02999 6.85528 7.32471 7.13642 6.80577 7.637C6.28683 8.13772 5.99703 8.8167 6.00039 9.52337V14.1561H9.93444C10.2051 12.7822 11.1294 11.6093 12.4322 10.9872C13.7348 10.3648 15.2656 10.3648 16.5681 10.9872C17.8709 11.6093 18.7952 12.7822 19.0659 14.1561H23V9.52337C23.0033 8.8167 22.7135 8.13772 22.1946 7.637C21.6756 7.13645 20.9704 6.85531 20.2352 6.85596H20.235ZM20.9806 9.7038C20.734 9.70482 20.5111 9.56263 20.4162 9.34374C20.3214 9.12485 20.3732 8.87245 20.5477 8.70491C20.7221 8.5372 20.9845 8.4872 21.2122 8.57837C21.4399 8.6697 21.588 8.884 21.587 9.12111C21.587 9.27554 21.5231 9.42385 21.4093 9.53321C21.2957 9.64241 21.1415 9.7038 20.9806 9.7038ZM16.1806 17.2315C15.6912 17.5711 15.1034 17.7541 14.4999 17.7551C13.8964 17.7541 13.3087 17.5711 12.8193 17.2315C12.33 16.892 11.9642 16.4132 11.7732 15.863C11.5823 15.3089 11.5823 14.7104 11.7732 14.1562C12.0289 13.4177 12.5968 12.8172 13.3373 12.5024C14.0778 12.1874 14.9221 12.1874 15.6625 12.5024C16.403 12.8172 16.9709 13.4177 17.2266 14.1562C17.4175 14.7103 17.4175 15.3088 17.2266 15.863C17.0357 16.4132 16.6698 16.892 16.1806 17.2315Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13439_38358"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.855957,
    width: 29,
    height: 29,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramFooter);
export default __webpack_public_path__ + "static/media/instagram-footer.2fe263251a57b3fabc872aaf69395ecc.svg";
export { ForwardRef as ReactComponent };